import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { RestaurantItem } from '@api/restaurant/restaurant-item';
import { BehaviorSubject, Observable } from 'rxjs';
import { LazyResolver } from '../../../../common/src/lib/lazy-resolver';

@Injectable({
  providedIn: 'root',
})
export class RestaurantService {
  private restaurant = new LazyResolver<RestaurantItem | null>(() => this.load());
  private loadingSubject = new BehaviorSubject<boolean>(true);
  private unableToLoadSubject = new BehaviorSubject<boolean>(false);

  constructor(private api: ApiService) {}

  get loading$() {
    return this.loadingSubject.asObservable();
  }
  get unableToLoad$() {
    return this.unableToLoadSubject.asObservable();
  }

  get(): Promise<RestaurantItem | null> {
    return this.restaurant.get();
  }

  observe(): Observable<RestaurantItem | null> {
    return this.restaurant.observe();
  }

  retryGet() {
    this.loadingSubject.next(true);
    this.unableToLoadSubject.next(false);
    this.restaurant.reload();
  }

  private async load(): Promise<RestaurantItem | null> {
    try {
      const result = await this.api.rpcClient.call('get-restaurant', {
        url: window.location.origin,
      });
      return result;
    } catch (e) {
      this.unableToLoadSubject.next(true);
      throw e;
    } finally {
      this.loadingSubject.next(false);
    }
  }
}
